import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  width: 22px;
  height: 22px;

  &:after {
    content: " ";
    display: block;
    width: 22px;
    height: 22px;
    margin: 2px;
    border-radius: 50%;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.3) transparent rgba(255, 255, 255, 0.6) transparent;
    animation: ${spin} 1.2s linear infinite;

    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  }
`;


function Spinner(props) {
    return (
      <SpinnerWrapper /> 
    );
}

export default Spinner;